import { render, staticRenderFns } from "./PotensiView.vue?vue&type=template&id=c55c49ba&scoped=true"
import script from "./PotensiView.vue?vue&type=script&lang=js"
export * from "./PotensiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55c49ba",
  null
  
)

export default component.exports